import * as React from 'react';
import { BillingDetailsProperties } from './interfaces/BillingDetailsInterfaces';
import { Elements } from '@stripe/react-stripe-js';
import { stripePromise } from '../../../utils/constants';
import { BillingDetailsInputForm } from './BillingDetailsInputForm';

export class BillingDetailsElement extends React.Component<BillingDetailsProperties> {
    constructor(props: any) {
        super(props);
    }

    render() {
        return (
                <Elements
                    options={{ locale: 'en' }}
                    stripe={stripePromise}
                >
                    <BillingDetailsInputForm
                        billingAddress={this.props.billingAddress}
                        cardData={this.props.cardData}
                        onReset={this.props.onReset}
                        onCardDataChange={this.props.onCardDataChange}
                        onCommit={this.props.onCommit}
                        isCommitInitiated={this.props.isCommitInitiated}
                        billingName={this.props.billingName}
                        description={this.props.description}
                        onAddressDataChange={this.props.onAddressDataChange}
                        taxInfo={this.props.taxInfo}
                    />
                </Elements>
        );
    }

}



// WEBPACK FOOTER //
// ./src/webportal/components/billing/details/BillingDetailsElement.tsx